import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './Price.module.scss';

interface PriceProps {
    price: string;
    refund?: boolean;
    className?: string;
}

export const Price: FunctionComponent<PriceProps> = props => {
    return (
        <div className={clsx(styles.container, { [styles.refund]: props.refund }, props.className)}>
            <span className={styles.text}>
                $
                {Number(props.price).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}
            </span>
        </div>
    );
};

export default Price;
